import { render } from "./ReturnFormDetail.vue?vue&type=template&id=72bedfdc&scoped=true"
import script from "./ReturnFormDetail.vue?vue&type=script&lang=js"
export * from "./ReturnFormDetail.vue?vue&type=script&lang=js"

import "./ReturnFormDetail.vue?vue&type=style&index=0&id=72bedfdc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bedfdc"]])

export default __exports__